import { render, staticRenderFns } from "./BlackJackPanel.vue?vue&type=template&id=520b16da&"
import script from "./BlackJackPanel.vue?vue&type=script&lang=js&"
export * from "./BlackJackPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports